@if (address) {
    <div>
        @if (!isEditMode) {
            <address [style.margin-bottom]="removeBottomMargin ? 0 : 'initial'">
                {{ address.address1 }} <br />
                {{ address.address2 }}
                @if (address.address2) {
                    <br />
                }
                {{ address.city }}
                @if (address.city) {
                    <span>, </span>
                }
                <state-dropdown
                    [stateId]="address.stateID"
                    [stateAbbr]="address.abbr"
                    [readOnly]="true"
                ></state-dropdown>
                {{ address.zip }} <br />
                @if (address.phone) {
                    <span><abbr title="Phone">P:</abbr> {{ address.phone }}</span>
                }
                @if (address.fax) {
                    <span style="margin-left: 5px"><abbr title="Fax">F:</abbr> {{ address.fax }}</span>
                }
                @if (address.phone || address.fax) {
                    <br />
                }
                <a href="mailto:{{ address.email }}" style="word-break: break-word">{{ address.email }}</a>
            </address>
        }
        @if (isEditMode) {
            <div style="display: flex; flex-direction: column; font-size: 0">
                <!-- Hack to remove whitespace between inputs -->
                <div>
                    <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'input-sm': isSmall }"
                        maxlength="50"
                        placeholder="Address 1"
                        [(ngModel)]="address.address1"
                    />
                </div>
                <div>
                    <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'input-sm': isSmall }"
                        maxlength="50"
                        placeholder="Address 2"
                        [(ngModel)]="address.address2"
                    />
                </div>
                <div style="display: flex">
                    <input
                        type="text"
                        class="form-control address-inline"
                        [ngClass]="{ 'input-sm': isSmall }"
                        maxlength="50"
                        placeholder="City"
                        [(ngModel)]="address.city"
                    />
                    <state-dropdown
                        [(stateId)]="address.stateID"
                        [(stateAbbr)]="address.abbr"
                        [isSmall]="isSmall"
                        [canSearch]="true"
                        [disabled]="readOnlyState"
                    ></state-dropdown>
                    <input
                        type="text"
                        class="form-control address-inline"
                        [ngClass]="{ 'input-sm': isSmall }"
                        maxlength="10"
                        placeholder="Zip"
                        [(ngModel)]="address.zip"
                    />
                </div>
                @if (!shouldRestrictExtended) {
                    <div>
                        <div style="display: flex">
                            <div class="input-group" style="width: 50%">
                                <span class="input-group-text">T</span>
                                <input
                                    type="tel"
                                    class="form-control"
                                    [ngClass]="{ 'input-sm': isSmall }"
                                    maxlength="18"
                                    placeholder="Phone"
                                    [(ngModel)]="address.phone"
                                />
                            </div>
                            <div class="input-group" style="width: 50%">
                                <span class="input-group-text">F</span>
                                <input
                                    type="tel"
                                    class="form-control"
                                    [ngClass]="{ 'input-sm': isSmall }"
                                    maxlength="18"
                                    placeholder="Fax"
                                    [(ngModel)]="address.fax"
                                />
                            </div>
                        </div>
                        <div class="input-group">
                            <span class="input-group-text" style="padding: 6px 9px">&#64;</span>
                            <input
                                type="email"
                                class="form-control"
                                [ngClass]="{ 'input-sm': isSmall }"
                                maxlength="100"
                                placeholder="email"
                                [(ngModel)]="address.email"
                            />
                        </div>
                    </div>
                }
            </div>
        }
        @if (shouldIncludeDetails) {
            <div>
                <a href>Address Details ()</a>
            </div>
        }
    </div>
}
